<template>
  <v-row class="dashboard-row">
    <v-col v-for="product in productos" :key="product.key" cols="12" sm="6" lg="3">
      <v-card elevation="2" class="dashboard-card product-card rounded-xl pa-4">
        <div class="product-content">
          <v-avatar :color="product.bg" size="68" class="product-avatar mr-4">
            <v-icon :color="product.color" size="36">{{ product.icon }}</v-icon>
          </v-avatar>
          <div class="product-info">
            <div class="dashboard-card-title">{{ product.nombre }}</div>
            <div class="product-amount">{{ product.valor }}</div>
            <div v-if="product.detalle" class="caption grey--text text--darken-1">{{ product.detalle }}</div>
          </div>
        </div>
        <v-btn
          block
          rounded
          :outlined="!product.filled"
          :depressed="product.filled"
          :dark="product.filled"
          :color="product.buttonColor"
          :to="product.to"
          class="product-button"
        >
          {{ getProductAction(product) }}
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ProductCardsGrid",
  props: {
    productos: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getProductAction(product) {
      const productName = `${product.key || ""} ${product.nombre || ""}`.toLowerCase();
      const isDapProduct = productName.includes("dap") || productName.includes("depósito") || productName.includes("deposito");

      if (isDapProduct && !product.status) return "Abrir DAP";

      return product.accion;
    }
  }
};
</script>

<style scoped>
.dashboard-row > .col,
.dashboard-row > [class*="col-"] {
  padding-bottom: 8px;
  padding-top: 8px;
}

.dashboard-card {
  width: 100%;
  background: #ffffff !important;
  border: 1px solid rgba(31, 45, 53, 0.08);
  box-shadow: 0 10px 28px rgba(20, 52, 57, 0.1) !important;
}

.product-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 150px;
  padding: 18px 20px 16px !important;
}

.product-content {
  align-items: center;
  display: flex;
  margin-bottom: 14px;
}

.product-avatar {
  flex: 0 0 auto;
}

.product-info {
  min-width: 0;
}

.product-button {
  height: 34px !important;
  text-transform: none;
  font-weight: 700;
}

.dashboard-card-title {
  color: #20333a;
  font-size: 0.94rem;
  font-weight: 700;
  line-height: 1.2;
}

.product-amount {
  color: #20333a;
  font-size: 1.38rem;
  font-weight: 400;
  line-height: 1.25;
}

@media (max-width: 599px) {
  .product-card {
    min-height: 132px;
  }

  .product-content {
    align-items: flex-start;
  }

  .product-avatar {
    height: 54px !important;
    min-width: 54px !important;
    width: 54px !important;
  }

  .product-avatar .v-icon {
    font-size: 30px !important;
  }

  .product-amount {
    font-size: 1.16rem;
    overflow-wrap: anywhere;
  }
}
</style>
